import React from 'react';

import { theme } from '@garnish/constants';

import { ScreenHeaderButton } from '../ScreenHeaderButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderScanButton = (props: Props) => {
  const { title, onPress } = props;

  return (
    <ScreenHeaderButton.Container palette="light" accessibilityLabel={title} onPress={onPress}>
      <ScreenHeaderButton.Icon color={theme.colors.DARK_KALE} name="IconScan" />
      <ScreenHeaderButton.Title color={theme.colors.DARK_KALE} bold={false}>
        {title}
      </ScreenHeaderButton.Title>
    </ScreenHeaderButton.Container>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
  onPress: () => void;
};
